import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getOrderItemReviews, getReviewsByUserId } from 'Redux/ducks/user-review';
import AccountOverview from 'Components/Account/AccountOverview/AccountOverview';
import attachReviewsToItems from 'Helpers/Order/OrderItemReviewHelper';

const AccountOverviewContainer = ({
  wishlistNumber,
  email,
  siteTheme,
  twoFactorEnabled,
  userId,
}) => {
  const [items, setItems] = useState([]);
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const _items = await getOrderItemReviews();
        const _reviews = await getReviewsByUserId();
        const orderItemReviews = attachReviewsToItems(_items, _reviews);
        setItems(orderItemReviews);
      } catch (e) {
        setFetchError(true);
      }
    };
    fetchItems();
  }, []);

  return (
    <AccountOverview
      reviews={items}
      reviewsError={fetchError}
      wishlistNumber={wishlistNumber}
      email={email}
      siteTheme={siteTheme}
      userId={userId}
      twoFactorEnabled={twoFactorEnabled}
    />
  );
};

AccountOverviewContainer.propTypes = {
  wishlistNumber: PropTypes.number,
  email: PropTypes.string,
  userId: PropTypes.string.isRequired,
  siteTheme: PropTypes.string,
  twoFactorEnabled: PropTypes.bool,
};

AccountOverviewContainer.defaultProps = {
  wishlistNumber: 0,
  email: '',
  siteTheme: '',
  twoFactorEnabled: false,
};

const mapStateToProps = ({
  wishlist: { count },
  auth: {
    email,
    _id,
    twoFactorEnabled,
  },
  siteTheme,
}) => ({
  wishlistNumber: count,
  email,
  userId: _id,
  twoFactorEnabled,
  siteTheme,
});

export default connect(mapStateToProps)(AccountOverviewContainer);
